import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
import interceptErrors from './intercept-errors';
var FetchResponseError = /*#__PURE__*/function (_Error) {
  _inherits(FetchResponseError, _Error);
  var _super = _createSuper(FetchResponseError);
  function FetchResponseError(_ref) {
    var _this;
    var url = _ref.url,
      _ref$response = _ref.response,
      response = _ref$response === void 0 ? {} : _ref$response,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      options = _ref.options,
      message = _ref.message,
      pageActionName = _ref.pageActionName;
    _classCallCheck(this, FetchResponseError);
    var _ref2 = options || {},
      _ref2$headers = _ref2.headers,
      headers = _ref2$headers === void 0 ? {} : _ref2$headers;
    _this = _super.call(this, message);
    var traceId = headers['x-b3-traceid'] || headers['X-B3-TraceId'];
    if (data.error && data.error.errors || data.error_id || data.errors || response && !response.ok) {
      _this.errors = interceptErrors({
        url: url,
        data: data,
        response: response,
        traceId: traceId,
        pageActionName: pageActionName
      });
    }
    _this.message = response.ok ? 'Successful response with errors' : data.message || message;
    _this.data = data;
    _this.response = response;
    _this.traceId = traceId;
    _this.visitId = headers['x-nike-visitid'];
    _this.visitorId = headers['x-nike-visitorid'];
    return _this;
  }
  return FetchResponseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export default FetchResponseError;